.icon__wrapper {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-200);
  border-radius: 0.5rem;
  color: var(--color-grey-500);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem 1rem;
}

.icon__item {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
  width: 100%;
}

.icon__item p {
  color: black;
  font-size: 13px;
  margin-left: 15px;
}
